"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.changePlanOutputDtoSchema = exports.changePlanInputDtoSchema = exports.purchasePackOutputDtoSchema = exports.purchasePackInputDtoSchema = exports.getCreditPacksOutputDtoSchema = exports.getCreditPacksInputDtoSchema = exports.getAiBalanceOutputDtoSchema = exports.getAiBalanceInputDtoSchema = exports.getDesignMonthHistoryOutputDtoSchema = exports.getDesignMonthHistoryInputDtoSchema = exports.getDesignMonthBalanceOutputDtoSchema = exports.getDesignMonthBalanceInputDtoSchema = void 0;
const z = __importStar(require("zod"));
exports.getDesignMonthBalanceInputDtoSchema = z.object({
    organizationId: z.string().min(1),
});
exports.getDesignMonthBalanceOutputDtoSchema = z.object({
    available: z.number(),
    total: z.number(),
    netBalance: z.number(),
    unreconciledAmount: z.number(),
    periodEnd: z.string(),
});
exports.getDesignMonthHistoryInputDtoSchema = z.object({
    organizationId: z.string().min(1),
});
exports.getDesignMonthHistoryOutputDtoSchema = z.object({
    months: z.array(z.object({
        windowStart: z.string(),
        windowEnd: z.string(),
        used: z.number(),
    })),
});
exports.getAiBalanceInputDtoSchema = z.object({
    organizationId: z.string().min(1),
});
exports.getAiBalanceOutputDtoSchema = z.object({
    credits: z.number().nullable(),
    included: z.number().nullable(),
    wallet: z.number().nullable(),
    aiGated: z.boolean(),
    includedTotal: z.number().nullable(),
});
exports.getCreditPacksInputDtoSchema = z.object({
    organizationId: z.string().min(1),
});
exports.getCreditPacksOutputDtoSchema = z.object({
    packs: z.array(z.object({
        id: z.string(),
        credits: z.number(),
        priceUsd: z.number(),
    })),
});
exports.purchasePackInputDtoSchema = z.object({
    organizationId: z.string().min(1),
    purchaseId: z.guid(),
    pack: z.string().min(1),
});
exports.purchasePackOutputDtoSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('ok'), purchaseRecordId: z.string().nullable() }),
    z.object({ status: z.literal('no_payment_instrument'), stripeSetupIntentClientSecret: z.string().nullable() }),
    z.object({
        status: z.literal('payment_failed'),
        stripeInvoiceUrl: z.string().nullable(),
        purchaseRecordId: z.string(),
    }),
]);
exports.changePlanInputDtoSchema = z.object({
    organizationId: z.string().min(1),
    targetPackageAlias: z.string().min(1),
});
exports.changePlanOutputDtoSchema = z.object({
    accepted: z.boolean(),
});
//# sourceMappingURL=billing.dto.js.map